import type { SVGProps } from 'react'
const LocationDocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 210 210"
    {...props}
  >
    <g filter="url(#Location_Document_svg__a)">
      <rect
        width={144}
        height={144}
        x={32.801}
        y={23.6}
        fill="#fff"
        rx={30.29}
      />
      <path
        fill="#C8D3F7"
        d="M128.399 79.345c9.328.76 13.991 1.14 16.653 4.274s2.281 7.798 1.52 17.125l-.538 6.596c-.76 9.327-1.141 13.991-4.275 16.652s-7.797 2.282-17.125 1.521l-26.382-2.151c-9.327-.761-13.99-1.141-16.652-4.275s-2.281-7.798-1.52-17.125l.537-6.596c.76-9.327 1.141-13.991 4.275-16.653 3.134-2.66 7.798-2.28 17.125-1.52z"
      />
      <path
        fill="#2852E4"
        d="M105.742 70.137c9.04-2.422 13.56-3.633 17.12-1.577s4.772 6.575 7.194 15.615l1.713 6.392c2.422 9.04 3.633 13.559 1.577 17.12-2.056 3.56-6.575 4.771-15.615 7.193l-25.567 6.851c-9.04 2.422-13.56 3.633-17.12 1.578-3.561-2.056-4.772-6.576-7.194-15.615l-1.713-6.392c-2.422-9.04-3.633-13.56-1.577-17.12s6.575-4.772 15.615-7.194z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={3.125}
        d="m77.422 92.284 37.553-10.062M106.912 103.263l12.774-3.463M81.788 107.307l3.496 1.722a.78.78 0 0 0 1.046-.356l4.823-9.793"
      />
    </g>
    <defs>
      <filter
        id="Location_Document_svg__a"
        width={209.028}
        height={209.028}
        x={0.287}
        y={0.461}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={9.375} />
        <feGaussianBlur stdDeviation={16.257} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_7340" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1_7340"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default LocationDocumentIcon
